import React from 'react';
import { Box, Typography } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { terminalColors } from '../../theme/terminalStyles';

/**
 * Заглушка замість фото товару — палітра терміналу (крем / помаранчевий).
 */
const ProductImagePlaceholder = ({ compact = false, sx }) => (
  <Box
    role="img"
    aria-label="Фото відсутнє"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      boxSizing: 'border-box',
      borderRadius: 2,
      bgcolor: 'rgba(255, 179, 71, 0.1)',
      border: `2px dashed ${terminalColors.accentOrange}`,
      gap: compact ? 0.5 : 1,
      py: compact ? 2 : 3,
      px: 2,
      ...sx,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: compact ? 64 : 88,
        height: compact ? 64 : 88,
        borderRadius: '50%',
        bgcolor: 'rgba(255, 179, 71, 0.22)',
        border: `2px solid ${terminalColors.accentOrange}`,
        flexShrink: 0,
      }}
    >
      <Inventory2OutlinedIcon
        sx={{
          fontSize: compact ? 36 : 52,
          color: terminalColors.accentOrangeHover,
        }}
      />
    </Box>
    {!compact ? (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 500, fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
      >
        Фото відсутнє
      </Typography>
    ) : null}
  </Box>
);

export default ProductImagePlaceholder;
